import { gql } from "@apollo/client";
import { Database } from "@nozbe/watermelondb";
import { DeletionResponseDeepNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";
import {
  DeletionResponse,
  DeletionResult,
} from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import { default as LayoutNode } from "../../data/model/LayoutNode";
import { AsyncLayoutActionDefinition } from "../types";

export const deleteLayoutNodeMutation = gql`
  ${DeletionResponseDeepNestingFragment}
  mutation DeleteLayoutNode($id: ID!) {
    deleteLayoutNode(id: $id) {
      ...DeletionResponseDeepNesting
    }
  }
`;

export const deleteLayoutKeyDefinition = new AsyncLayoutActionDefinition<
  DeletionResponse,
  DeletionResponse,
  (database: Database, id: string) => Promise<DeletionResponse>,
  (id: string) => Promise<DeletionResponse>
>({
  localAction: async (database: Database, id: string) => {
    return database.write(async () => {
      return database.collections
        .get<LayoutNode>("layout_nodes")
        .find(id)
        .then((res) =>
          res
            .destroyPermanently()
            .then(mockDeletionResponseSuccess)
            .catch(mockDeletionResponseFailure)
        );
    });
  },
  remoteAction: async (id: string) => {
    return client
      .mutate({
        variables: { id: id },
        mutation: deleteLayoutNodeMutation,
      })
      .then((result) => {
        return result.data?.deleteLayoutNode;
      });
  },
});

function mockDeletionResponseSuccess(): DeletionResponse {
  return {
    result: DeletionResult.DELETED,
  };
}

function mockDeletionResponseFailure(e: any): DeletionResponse {
  return {
    result: DeletionResult.NOT_DELETED,
    reason: e?.message,
  };
}
